import { Head } from '@unhead/react';

/** Sets common page metatags via Helmet. This executes client-side during hydration,
 * and at site build-time via render-entry-pages.tsx. Defaults for some of these are
 * set in apps/web/src/app/app.tsx.
 */
const MetaTags = ({
  title,
  description,
  imageUrl,
}: {
  title?: string;
  description?: string;
  imageUrl?: string;
}) => {
  return (
    <Head>
      {title && <title>{title}</title>}
      {description && <meta name='description' content={description} />}
      {title && <meta property='og:title' content={title} />}
      {description && <meta property='og:description' content={description} />}
      {imageUrl && <meta property='og:image' content={imageUrl} />}

      {!import.meta.env.SSR && <meta property='og:url' content={document.location.toString()} />}
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content='MovingWorlds.org' />
    </Head>
  );
};

export default MetaTags;
